module.exports = __webpack_public_path__ + "static/media/project3.fe4eb302.png";